module.exports = __webpack_public_path__ + "static/media/picture-(23).2b8c8ca6.JPG";